import React, { useContext } from "react";
// React Bootstrap
import { Accordion, Card, Button } from "react-bootstrap";
// Componentes
import VistaMision from "../vistas/VistaInfoMision";
import FormInfoMision from "../formularios/FormInfoMision";
// Contexto
import { ModalContext } from "../../../../context/modalContext";

const InfoMision = ({ datosMision, handlePutDatosMision }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);

  return (
    <Accordion defaultActiveKey="1">
      <Card>
        <Card.Header>
          <Accordion.Toggle eventKey="0" as={Button} variant="link">
            Información general
          </Accordion.Toggle>
          <Button
            variant="outline-primary"
            size="sm"
            className="float-right mr-4"
            onClick={() => {
              modalSetShow(true, "80%");
              modalSetTitle(`Editar datos ${datosMision?.type}`);
              modalSetContent(<FormInfoMision defaultValues={datosMision} submissionHandler={handlePutDatosMision} />);
            }}
          >
            Editar
          </Button>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body className={"bg-light"}>
            <VistaMision datosMision={datosMision} />
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};

export default InfoMision;
